import React from "react";
import "./SignUp.css";
import { ReactComponent as UserIcon } from "./assets/user-icon.svg";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// user-icon src

const ForgotPassword = () => {
  const [password, setPassword] = useState({
    password: "",
  });

  const [tokenEmail, setTokenEmail] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    if (token) {
      // Do something with the token
      console.log(token);
      setTokenEmail(token);

      // Edit the URL
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete("token");
      window.history.pushState({}, "", newUrl);
    }
  }, []);

  const handlePassword = (event) => {
    setPassword({
      ...password,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangePassword = async () => {
    try {
      const response = await fetch(
        `https://foodie-review-app.netlify.app/auth/reset-password/${tokenEmail}`,
        {
          password: password.password,
        }
      );

      if (response.ok) {
        // Password reset successful
        navigate("/login"); // Route to the login page
        window.close(); // Close the current tab
      } else {
        console.log("Password reset failed");
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 manual">
      <div className="max-w-md w-full space-y-8">
        <div>
          <UserIcon className="mx-auto h-16 w-auto" />
        </div>
        <form className="mt-8 space-y-6">
          <div className="rounded-md shadow-sm space-y-4">
            {tokenEmail && (
              <div>
                <label
                  htmlFor="password"
                  className="block text-gray-700 font-bold mb-2"
                >
                  New Password
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-red-600 focus:border-red-600 focus:z-10 sm:text-sm"
                  placeholder="New Password"
                  value={password.password}
                  onChange={handlePassword}
                />
              </div>
            )}
          </div>

          {tokenEmail && (
            <div className="flex flex-col items-center justify-center mt-4 space-y-4">
              <button
                type="submit"
                onClick={handleChangePassword}
                className="group relative w-auto flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 rounded-lg"
              >
                Change Password
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
